<template>
    <Button
        label="Relatório de Conciliação"
        class="p-button-primary mr-2"
        icon="pi pi-download"
        @click="exportarArquivoRelatorio()"
        v-if="mostrarBtnRelatorioConciliacao"
        aria-haspopup="true"
        aria-controls="overlay_menu"
    />
</template>

<script>
import services from './service';

export default {
    data() {
        return {};
    },

    methods: {
        toggle(event) {
            this.$refs.menu.toggle(event);
        },

        exportarArquivoRelatorio() {
            this.$store.dispatch('addRequest');
            services.obterRelatorioConciliacaoPdf().then((response) => {
                if (response?.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Relatório de Conciliação',
                        detail: 'Relatório obtido com sucesso!',
                        life: 3000,
                    });
                    let nomeArquivo = `Relatorio_Conciliacao_${this.$moment(new Date()).format('DD-MM-YYYY_HH-mm')}.xlsx`;
                    this.$download(response.data, nomeArquivo);
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Relatório de Conciliação',
                        detail: 'Falha ao obter relatório de conciliação',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    computed: {
        mostrarBtnRelatorioConciliacao() {
            return this.$temAcessoView('CHECKOUTS-PAGAMENTOS-08');
        },
    },
};
</script>
